'use strict';

(function () {
  // Wait for the DOM to fully load
  document.addEventListener("DOMContentLoaded", function () {
    // Function to sanitize input (now simplified)
    function sanitizeInput(str) {
      const temp = document.createElement("div");
      temp.innerHTML = str;
      return temp.textContent || temp.innerText;
    }

    const PRODUCT_FIELD_NAME = 'contact[product]';

    // Check if URLSearchParams is supported
    if ('URLSearchParams' in window) {
      const urlParams = new URLSearchParams(window.location.search);
      const yp = urlParams.get("yp") || '';
      const ys = urlParams.get("ys") || '';

      if (yp && ys) {
        // Decode URL-encoded parameters
        const decodedYp = decodeURIComponent(yp);
        const decodedYs = decodeURIComponent(ys);

        // Sanitize inputs
        const safeYp = sanitizeInput(decodedYp);
        const safeYs = sanitizeInput(decodedYs);

        const combinedValue = `[${safeYs}] ${safeYp}`;
        const formField = document.querySelector(`input[name="${PRODUCT_FIELD_NAME}"]`);

        if (formField) {
          formField.value = combinedValue;
        } else {
          console.warn(`Form field "${PRODUCT_FIELD_NAME}" not found.`);
        }
      }
    } else {
      console.error('URLSearchParams is not supported in this browser.');
      // Implement alternative parsing if necessary
    }
  });
})();
